import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant' // Using 'instant' instead of 'smooth' for immediate scroll
        });
    }, [pathname]);

    return null; // This component doesn't render anything
};

export default ScrollToTop; 